"use strict";

var _regeneratorRuntime = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var use_async_state_hook_1 = __importDefault(require("./use-async-state.hook"));

var react_1 = require("react");

var useAsyncFuncWithState = function useAsyncFuncWithState(asyncFunc) {
  var _use_async_state_hook = use_async_state_hook_1.default(),
      state = _use_async_state_hook.state,
      dispatchStartAction = _use_async_state_hook.dispatchStartAction,
      dispatchSuccessAction = _use_async_state_hook.dispatchSuccessAction,
      dispatchFailureAction = _use_async_state_hook.dispatchFailureAction,
      dispatchResetAction = _use_async_state_hook.dispatchResetAction;

  var _react_1$useState = react_1.useState(),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      data = _react_1$useState2[0],
      setData = _react_1$useState2[1];

  var proceed = react_1.useCallback(function _callee() {
    var _data,
        _args = arguments;

    return _regeneratorRuntime.async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dispatchStartAction();
            _context.prev = 1;
            _context.next = 4;
            return _regeneratorRuntime.awrap(asyncFunc.apply(void 0, _args));

          case 4:
            _data = _context.sent;
            setData(_data);
            dispatchSuccessAction();
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            dispatchFailureAction(_context.t0);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, [[1, 9]]);
  }, [asyncFunc, dispatchStartAction, dispatchSuccessAction, dispatchFailureAction]);
  var reset = react_1.useCallback(function () {
    dispatchResetAction();
  }, [dispatchResetAction]);
  return {
    state: state,
    data: data,
    proceed: proceed,
    reset: reset
  };
};

exports.default = useAsyncFuncWithState;